

import { get } from './commonFetch';

import type { TripNotification } from '../types/tripNotification';

export const getTripNotification = (
  tripId: string,
  notificationId: string,
): Promise<TripNotification> => {
  return get(`/api/trips/${tripId}/notifications/${notificationId}`);
};
